import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useCurrentUser } from "@/currentUser/CurrentUserProvider";
import { SettingsDirectoryPage } from "@/settings/SettingsDirectoryPage";
import { affiliateGroups } from "@/settings/settingsDirectory";

export const Route = createFileRoute("/_authenticated/affiliate-management")({
  component: AffiliateManagementPage,
});

function AffiliateManagementPage(): ReactNode {
  // The active affiliate's name comes from the already-loaded current-user
  // profile; the affiliate root directory the switcher reads is
  // ROLE_OIDC_ADMIN-only and must not be used as a general-purpose name source.
  const { affiliateName } = useCurrentUser();

  return (
    <SettingsDirectoryPage
      title="Organisatiebeheer"
      description={`Beheer de inrichting van ${affiliateName}.`}
      searchLabel="Zoek in organisatiebeheer"
      groups={affiliateGroups}
    />
  );
}
